import Tools from '../../../tools/tools.js';

import {
  MessageTableData
} from './message.style';

const tools = new Tools();

const Message = ({ message }) => {
  const { status, replied, metadata = {}, createdAt } = message;
  const { firstName = '', lastName = '' } = metadata;

  const displayStatus = () => {
    if (status === 'pending') return 'New';
    if (status === 'read') return 'Read';
    if (status === 'archived') return 'Archived';
    return status;
  };

  return (
    <>
      <MessageTableData>{displayStatus()}</MessageTableData>
      <MessageTableData>{replied ? 'Yes' : 'No'}</MessageTableData>
      <MessageTableData>{`${firstName} ${lastName}`.trim() || 'Anonymous'}</MessageTableData>
      <MessageTableData>{tools.formatCreatedAtDate(createdAt)}</MessageTableData>
    </>
  );
};

export default Message;